import {sum} from "@Common/utils/collections";
import {chain} from "@Common/utils/fs";

export const getFields = ({config, savedData}) => {

    let temp = {...config?.fields};

    // console.log("config", config);
    const billingAdjustmentField = chain(
        extractField("billingAdjustment", temp),
        (_) => _ && ({
            ..._,
            getSuggestedValue: (savedData) => savedData ? (
                sum(savedData, (d) => +(d.amount || 0))
            ) : (
                +(config.amountAvailable || 0)
            ),
            maxValue: config.amountAvailable,
        }),
    );

    const commentsField = extractField("comments", temp);

    return [
        billingAdjustmentField,
        ...Object.keys(temp).map((name) => extractField(name, temp)),
        commentsField,
    ].filter(v=>v);
};
const extractField = (name, temp) => {
    const v1 = temp[name];
    if (!v1) {
        return null;
    }

    const field = {
        ...v1,
        path: name,
        initData: (savedData) => savedData[0][name],
        ...v1[name + "Dropdown"] && {
            type: "array",
            values: v1[name + "Dropdown"].split(","),
        },
    };
    delete temp[name];
    return field;
};

